import { getSpreadingAction } from 'automaton/actions/SpreadingAction'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { getFreespinsWinState } from 'automaton/states/FreespinsWinState'

export function getSpreadState() {
  const winModel = game.models.WinModel.get()
  const freespinModel = game.models.FreespinModel.get()

  const name = 'SPREAD'
  const actions = [getSpreadingAction()]
  const transition = () => winModel.expendingWinLines.length
    ? getFreespinsWinState()
    : freespinModel.left
      ? getFreespinsSpinState()
      : getFreespinEndState()

  return {
    name,
    actions,
    transition,
  }
}
